import { c as _c } from "react/compiler-runtime";
import type { DataIdentifier, DocumentKind } from '@onefootprint/request-types/dashboard';
import { useTranslation } from 'react-i18next';
import type useEntityVault from '@/components/entities/hooks/use-entity-vault';
import useDataLabelText from '../../../hooks/use-data-label-text';
import getDataValue from '../../../utils/get-data-value';
import Decrypt from './decrypt';
export type IdentityDataContentProps = {
  documentKind: DocumentKind;
  vault: ReturnType<typeof useEntityVault>;
  isDecrypted: boolean;
  canDecrypt: boolean;
  dis: DataIdentifier[];
  seqno: number | undefined;
};
const IdentityDataContent = t0 => {
  const $ = _c(22);
  const {
    documentKind,
    vault,
    isDecrypted,
    canDecrypt,
    dis,
    seqno
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "fieldset.documents.details.identity"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  const dataLabelT = useDataLabelText();
  if (!isDecrypted) {
    let t2;
    if ($[1] !== seqno) {
      t2 = seqno?.toString();
      $[1] = seqno;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    let t3;
    if ($[3] !== canDecrypt || $[4] !== documentKind || $[5] !== t2 || $[6] !== vault.data || $[7] !== vault.update) {
      t3 = <Decrypt documentType={documentKind} onDecryptSuccess={vault.update} canDecrypt={canDecrypt} vaultData={vault.data} seqno={t2} />;
      $[3] = canDecrypt;
      $[4] = documentKind;
      $[5] = t2;
      $[6] = vault.data;
      $[7] = vault.update;
      $[8] = t3;
    } else {
      t3 = $[8];
    }
    return t3;
  }
  if (dis.length === 0) {
    let t2;
    if ($[9] !== t) {
      t2 = t(_temp);
      $[9] = t;
      $[10] = t2;
    } else {
      t2 = $[10];
    }
    let t3;
    if ($[11] !== t2) {
      t3 = <span className="text-body-2 text-tertiary">{t2}</span>;
      $[11] = t2;
      $[12] = t3;
    } else {
      t3 = $[12];
    }
    return t3;
  }
  let t2;
  if ($[13] !== dataLabelT || $[14] !== dis || $[15] !== vault) {
    let t3;
    if ($[17] !== dataLabelT || $[18] !== vault) {
      t3 = key => {
        const vaultValue = vault.data?.vault[key];
        const value = getDataValue(vaultValue, key);
        return <div key={key} className="flex justify-between gap-6"><p className="text-body-2 text-tertiary">{dataLabelT(key)}</p><p className="text-body-2 text-primary text-right wrap-anywhere md:wrap-normal" title={value} data-dd-privacy="mask">{value}</p></div>;
      };
      $[17] = dataLabelT;
      $[18] = vault;
      $[19] = t3;
    } else {
      t3 = $[19];
    }
    t2 = dis.map(t3);
    $[13] = dataLabelT;
    $[14] = dis;
    $[15] = vault;
    $[16] = t2;
  } else {
    t2 = $[16];
  }
  let t3;
  if ($[20] !== t2) {
    t3 = <div className="flex flex-col gap-2 w-full">{t2}</div>;
    $[20] = t2;
    $[21] = t3;
  } else {
    t3 = $[21];
  }
  return t3;
};
export default IdentityDataContent;
function _temp($) {
  return $.empty;
}